export default __webpack_public_path__ + "static/media/logo-skyground-black.bb5d9e19.svg";